import React, { useEffect, useState } from "react";
import "./HomePage.module.css";
import { Card, CardBody, Tooltip } from "@material-tailwind/react";
import { useNavigate } from "react-router-dom";
import { PlusIcon, ArrowRightIcon } from "@heroicons/react/24/solid";
import "./HomePage.module.css";
import { Caselet, get_user_data, delete_user_data_from_client_side, SeedType } from "../../utils/common";
import { CardSkeleton } from "../../utils/CardSkeleton";
import { getLogger } from "../../utils/logger";
import {
    checkUser,
    getDraftPrivateContentFiles,
    getFileChats,
    getFiles,
    getId,
    getUnPublishedCaseletFileInfo,
    getUnpublishedCaseletsFiles,
    saveUnpublishedCaselet
} from "../../api/axiosApi";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import { markdownComponents } from "../thoughts/chat/RenderResponse";
interface TitleComponentProps {
    timestamp: string;
    query: string;
    response: string;
    citations: string[];
}
type Thought = {
    filename: string;
    timestamp: string;
    query: string;
    response: string;
    citations: string[];
};

interface ThoughtProcessProps {
    isUserLoggedIn: Boolean;
}

function giveErrorMessage(statusCode: number | undefined) {
    switch (statusCode) {
        case 404:
            return (
                <Card className=" hover:cursor-pointer pb-4 w-full h-44 ">
                    <CardBody className="p-2 flex  justify-center  font-bold">Resource not found.</CardBody>
                </Card>
            );
        case 500:
            return (
                <Card className=" hover:cursor-pointer pb-4 w-full h-44 ">
                    <CardBody className="p-2 flex  justify-center  font-bold">Internal server error. Please try again later.</CardBody>
                </Card>
            );
        case 400:
            return (
                <Card className=" hover:cursor-pointer pb-4 w-full h-44 ">
                    <CardBody className="p-2 flex  justify-center  font-bold">Bad request. Please check your request and try again.</CardBody>
                </Card>
            );
        default:
            return (
                <Card className=" hover:cursor-pointer pb-4 w-full h-44 ">
                    <CardBody className="p-2 flex  justify-center  font-bold">Oops, something went wrong!</CardBody>
                </Card>
            );
    }
}

// export const ShowUnpublishedCaselet = () => {
//     const logger = getLogger();
//     const [caselet, setCaselet] = useState<Caselet[]>([]);
//     const [isHovered, setIsHovered] = useState(false);
//     const [isLoading, setIsLoading] = useState(true);
//     const [error, setError] = useState(false);
//     const [, setUserNotExist] = useState<boolean>(false);
//     const [statusCode, ] = useState<number | undefined>();
//     const [userDataAvailable, setUserDataAvailable] = useState(false);
//     const navigate = useNavigate();
//     async function fetchAndSetCaselets() {
//         try {
//             setIsLoading(true);
//             if (get_user_data() !== null && get_user_data() !== undefined) {
//                 const check_user_dir = await checkUser();
//                 const checkUserExist = await check_user_dir.data;
//                 console.log(checkUserExist);
//                 if (!checkUserExist.exists) {
//                     setUserNotExist(true);
//                     setIsLoading(false);
//                     setUserDataAvailable(true);
//                 } else {
//                     const caseletFilesResponse = await getUnpublishedCaseletsFiles();
//                     const caseletFiles = await caseletFilesResponse.data;
//                     if (caseletFiles.status == "error" && caseletFiles.message == "UNPUBLISHED_CASELET_DIR_NOT_AVAILABLE") {
//                         setUserDataAvailable(true);
//                         return;
//                     }

//                     caseletFiles.sort((a: any, b: any) => {
//                         const timestampA = Number(a.slice(0, -4)); // Remove '.txt' and convert to number
//                         const timestampB = Number(b.slice(0, -4)); // Remove '.txt' and convert to number
//                         return timestampB - timestampA; // Sort in descending order (most recent first)
//                     });
//                     const fetchedCaselets: Caselet[] = [];
//                     let numberOfFileNeedToGet = 4;
//                     for (let i = 0; i < Math.min(caseletFiles.length, numberOfFileNeedToGet); i++) {
//                         try {
//                             const caseletInfoResponse = await getUnPublishedCaseletFileInfo(caseletFiles[i].substring(0, caseletFiles[i].lastIndexOf(".")));
//                             const caseletInfo = await caseletInfoResponse.data;
//                             caseletInfo.fileName = caseletFiles[i].substring(0, caseletFiles[i].lastIndexOf("."));
//                             fetchedCaselets.push(caseletInfo);
//                         } catch (error) {
//                             numberOfFileNeedToGet++;
//                             console.error(`Failed to fetch caselet data `, error);
//                         }
//                     }

//                     setCaselet(fetchedCaselets);
//                     setIsLoading(false);
//                 }
//             } else {
//                 navigate("/user_login");
//             }
//         } catch (error) {
//             setError(true);
//             console.error(`Failed to fetch seed files `, error);
//         }
//     }

//     useEffect(() => {
//         fetchAndSetCaselets();
//     }, []);
//     const showCaseletList = () => {
//         navigate(`/unpublished-caselets`, { state: { from: "listCaselet" } });
//     };

//     const openSpecificCaseletClick = async (id: string) => {
//         try {
//             if (get_user_data() !== null && get_user_data() !== undefined) {
//                 const caseletInfoResponse = await getUnPublishedCaseletFileInfo(id);
//                 const caseletInfo = await caseletInfoResponse.data;

//                 if (caseletInfo.view !== undefined) {
//                     caseletInfo.view = caseletInfo.view + 1;
//                 } else {
//                     caseletInfo.view = 1;
//                 }
//                 saveUnpublishedCaselet(caseletInfo.id, caseletInfo);
//                 navigate(`/unpublished-caselets/${id}`), { state: { from: "singleCaselet" } };
//             } else {
//                 navigate("/user_login");
//             }
//         } catch (error) {
//             console.error(`Failed to fetch caselet data `, error);
//         }
//     };
//     if (userDataAvailable) {
//         return (
//             <Card className="flex justify-center items-center pb-4 w-full h-44 ">
//                 <CardBody className=" flex  justify-center text-slate-500 font-bold">There is nothing to show here.</CardBody>
//             </Card>
//         );
//     }
//     if (isLoading && error === false) {
//         return (
//             <div className="w-[89vw]">
//                 <CardSkeleton></CardSkeleton>
//             </div>
//         );
//     }
//     if (error) {
//         return giveErrorMessage(statusCode);
//     }
//     return (
//         <>
//             <div className="grid grid-cols-3 gap-3 w-full min-w-96">
//                 {caselet.slice(0, 3).map(caselet => {
//                     return (
//                         <Card
//                             key={caselet.id}
//                             onClick={() => openSpecificCaseletClick(caselet.id)}
//                             className=" hover:cursor-pointer pb-4 h-44 overflow-hidden min-w-32 "
//                             onMouseEnter={() => setIsHovered(true)}
//                             onMouseLeave={() => setIsHovered(false)}
//                         >
//                             <CardBody className="p-2">{caselet.title}</CardBody>
//                         </Card>
//                     );
//                 })}
//             </div>
//             <div className=" flex items-center justify-center  ">
//                 {caselet.length > 3 ? (
//                     <Tooltip content="View More" placement="top-end" className="text-white bg-green-800 font-bold p-2">
//                         <div onClick={showCaseletList} className="arrowForMore hover:cursor-pointer">
//                             <ArrowRightIcon className="arrow-icon text-green-800 h-6 w-6" />
//                         </div>
//                     </Tooltip>
//                 ) : (
//                     <div className="h-12 w-12"></div>
//                 )}
//             </div>
//         </>
//     );
// };

// const ThoughtProcess = () => {
//     const [thoughts, setThoughts] = useState<Thought[]>([]);
//     const navigate = useNavigate();
//     const [isLoading, setIsLoading] = useState(true);
//     const [error, setError] = useState(false);
//     const [, setUserNotExist] = useState(false);

//     const handleSeeMoreClick = () => {
//         navigate(`/interactions`, { state: { thoughts } });
//     };

//     useEffect(() => {
//         async function fetchThoughts() {
//             try {
//                 if (get_user_data() !== null && get_user_data() !== undefined) {
//                     const check_user_dir = await checkUser();
//                     const checkUserDirExist = await check_user_dir.data;
//                     if (!checkUserDirExist.exists) {
//                         setUserNotExist(true);
//                     } else {
//                         const thoughtsFilesResponse = await getFiles();
//                         const filesData = await thoughtsFilesResponse.data;
//                         if (filesData.status === "error" || filesData.message === "CHAT_DIR_NOT_AVAILABLE") {
//                             setIsLoading(false);
//                             return;
//                         } else if (filesData.length === 0) {
//                             setIsLoading(false);
//                             return;
//                         }

//                         filesData.sort((a: any, b: any) => {
//                             const timestampA = Number(a.slice(0, -4)); // Remove '.txt' and convert to number
//                             const timestampB = Number(b.slice(0, -4)); // Remove '.txt' and convert to number
//                             return timestampB - timestampA; // Sort in descending order (most recent first)
//                         });

//                         const fetchedThoughts: Thought[] = [];
//                         let numberOfFileNeedToLoad = 3;
//                         for (let i = 0; i < Math.min(filesData.length, numberOfFileNeedToLoad); i++) {
//                             try {
//                                 const historyResponse = await getFileChats(filesData[i].substring(0, filesData[i].lastIndexOf(".")));
//                                 const historyData = await historyResponse.data;
//                                 const latestThought = historyData[0];

//                                 latestThought["filename"] = filesData[i].substring(0, filesData[i].lastIndexOf("."));
//                                 fetchedThoughts.push(latestThought);
//                             } catch (error) {
//                                 numberOfFileNeedToLoad++;
//                                 console.error(`Failed to fetch thought data `, error);
//                             }
//                         }

//                         setThoughts(fetchedThoughts);
//                     }
//                     setIsLoading(false);
//                 } else {
//                     delete_user_data_from_client_side();
//                     navigate("/user_login");
//                 }
//             } catch (error) {
//                 setError(true);
//                 console.error(`Failed to fetch thought files `, error);
//             }
//         }

//         fetchThoughts();
//     }, []);

//     const openSpecificThoughtClick = (thought: Thought) => {
//         navigate(`/interaction/${thought.filename}`, { state: { from: "individual" } });
//     };
//     const fetchIdAndNavigate = async () => {
//         try {
//             const idResponse = await getId();
//             const id = await idResponse.data;

//             navigate(`/interaction/${id.Id}`, { state: { from: "new" } }); // Navigate after updating state
//         } catch (error) {
//             console.error("Failed to fetch ID and navigate", error);
//         }
//     };
//     const clickToCreateNewThought = () => {
//         fetchIdAndNavigate();
//     };

//     const truncate = (str: string, maxLength: number) => {
//         if (str.length <= maxLength) {
//             return str;
//         }

//         let truncatedString = str.substring(0, maxLength);
//         let lastSpaceIndex = truncatedString.lastIndexOf(" ");

//         if (lastSpaceIndex === -1) {
//             return truncatedString;
//         }

//         return truncatedString.substring(0, lastSpaceIndex) + " ...";
//     };

//     if (isLoading && error === false) {
//         return (
//             <div className="w-[89vw]">
//                 <CardSkeleton></CardSkeleton>
//             </div>
//         );
//     }
//     if (error) {
//         return (
//             <Card className=" hover:cursor-pointer pb-4 w-full h-44 ">
//                 <CardBody className="p-2 flex  justify-center  font-bold">Oops, something went wrong!</CardBody>
//             </Card>
//         );
//     }

//     return (
//         <>
//             <div className="grid grid-cols-3 gap-3 w-full min-w-96">
//                 <Card onClick={clickToCreateNewThought} className="hover:cursor-pointer pb-4  h-44 min-w-32">
//                     <CardBody className="p-2 h-screen flex items-center justify-center">
//                         <PlusIcon className="h-20 w-20 text-green-800 " />
//                     </CardBody>
//                     <div className="text-center flex justify-center text-gray-600">
//                         <span className="inline-block card_text_color text-sm"> Click to start a new interaction.</span>
//                     </div>
//                 </Card>
//                 {thoughts.slice(0, 2).map((thought, index) => (
//                     <Card key={index} onClick={() => openSpecificThoughtClick(thought)} className="hover:cursor-pointer pb-4 h-44 min-w-32 overflow-auto">
//                         <CardBody className="p-2">
//                             {thought.query}
//                         </CardBody>
//                     </Card>
//                 ))}
//             </div>
//             <div className="flex items-center justify-center ">
//                 {thoughts.length > 2 ? (
//                     <Tooltip content="View More" placement="top-end" className="text-white bg-green-800 font-bold p-2">
//                         <div onClick={handleSeeMoreClick} className="arrowForMore hover:cursor-pointer">
//                             <ArrowRightIcon className="arrow-icon text-green-800 h-6 w-6" />
//                         </div>
//                     </Tooltip>
//                 ) : (
//                     <div className="h-12 w-12"></div>
//                 )}
//             </div>
//         </>
//     );
// };
const DraftProcess = () => {
    const [draftContent, setDraftContent] = useState<SeedType[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const [userNotExist, setUserNotExist] = useState<boolean>(false);
    const [isHovered, setIsHovered] = useState(false);
    const [statusCode, setStatusCode] = useState<number | undefined>();
    const [userPrivateDirAvailable, setUserPrivateContentDirAvailable] = useState(true);
    const navigate = useNavigate();
    async function fetchTheDraft() {

        try {
            setIsLoading(true);
            if (get_user_data() !== null && get_user_data() !== undefined) {
                const check_user_dir = await checkUser();
                const checkUserExist = await check_user_dir.data;
                if (checkUserExist.exists === "false") {
                    setUserNotExist(true);
                    setIsLoading(false);
                    // setUserDataAvailable(true);
                } else {
                    const exclusiveFilesResponse = await getDraftPrivateContentFiles();
                    const exclusiveFiles = await exclusiveFilesResponse.data;
                    // console.log("exclusiveFiles: ", exclusiveFiles)
                    if (exclusiveFiles.status == "error" && exclusiveFiles.message === "PRIVATE_CONTENT_DIR_NOT_AVAILABLE") {
                        setUserPrivateContentDirAvailable(false);
                        setIsLoading(false);
                        return;
                    } else if (exclusiveFiles.length === 0) {
                        setUserPrivateContentDirAvailable(false);
                        setIsLoading(false);
                        return;
                    } else {
                        setUserPrivateContentDirAvailable(true);
                    }

                    const fetchedPrivateContent: any[] = [];
                    let numberOfFileNeedToGet = 4;
                    for (let i = 0; i < Math.min(exclusiveFiles.length, numberOfFileNeedToGet); i++) {
                        try {
                                fetchedPrivateContent.push(exclusiveFiles[i]);
                        } catch (error) {
                            numberOfFileNeedToGet++;
                            console.error(`Failed to fetch caselet data `, error);
                        }
                    }

                    setDraftContent(fetchedPrivateContent);
                    setIsLoading(false);
                }
            } else {
                navigate("/user_login");
            }
        } catch (error: any) {
            setError(true);
        }
    }
    const openSpecificDraftClick = (fileName: String) => (event: React.MouseEvent<HTMLDivElement>) => {
        navigate(`/my-exclusive-content/draft/${fileName}`, { state: { from: "individual", fileName: fileName } });
    };
    const showExclusiveContentList = () => {
        navigate(`/my-exclusive-content`);
    };
    const clickToCreateNewExclusiveContent = () => {
        navigate(`/my-exclusive-content/new`);
    };
    useEffect(() => {
        fetchTheDraft();
    }, []);
    if (isLoading && error === false) {
        return (
            <div className="w-[89vw]">
                <CardSkeleton></CardSkeleton>
            </div>
        );
    }

    if (error) {
        return (
            <Card className=" hover:cursor-pointer pb-4 w-full h-44 ">
                <CardBody className="p-2 flex  justify-center  font-bold">Oops, something went wrong!</CardBody>
            </Card>
        );
    }
    return (
        <>
            <div className="grid grid-cols-3 gap-3 w-full min-w-96">
                <Card onClick={clickToCreateNewExclusiveContent} className="hover:cursor-pointer pb-4  h-44 min-w-32">
                    <CardBody className="p-2 h-screen flex items-center justify-center">
                        <PlusIcon className="h-20 w-20 text-green-800 " />
                    </CardBody>
                    <div className="text-center flex justify-center text-gray-600">
                        <span className="inline-block card_text_color text-sm">Click to create new exclusive content.</span>
                    </div>
                </Card>
                {draftContent.slice(0, 2).map((content: any) => {
                    return (
                        <Card
                            key={content.id}
                            onClick={content.file_name ? openSpecificDraftClick(content.file_name) : openSpecificDraftClick(content.id)}
                            className=" hover:cursor-pointer pb-4 h-44 overflow-hidden min-w-32 "
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                        >
                            <CardBody className="p-2">{content.title}</CardBody>
                        </Card>
                    );
                })}
            </div>
            <div className=" flex items-center justify-center  ">
                {draftContent.length > 2 ? (
                    <Tooltip content="View More" placement="top-end" className="text-white bg-green-800 font-bold p-2">
                        <div onClick={showExclusiveContentList} className="arrowForMore hover:cursor-pointer">
                            <ArrowRightIcon className="arrow-icon text-green-800 h-6 w-6" />
                        </div>
                    </Tooltip>
                ) : (
                    <div className="h-12 w-12"></div>
                )}
            </div>
        </>
    );
};

const HomePage = () => {
    return (
        <div>
            <div className="cardsContainer ">
                <div className=" mt-6 mb-3 font-bold text-green-800">My Exclusive Content</div>

                <div className="flex gap-4">
                    <DraftProcess />
                </div>
            </div>
            {/* <div>
                <div className=" my-3 font-bold text-green-800">Interaction</div>

                <div className="flex gap-4">
                    <ThoughtProcess></ThoughtProcess>
                </div>
            </div> */}
            {/* <div className="cardsContainer ">
                <div className=" mt-6 mb-3 font-bold text-green-800">Un-Published Caselets</div>

                <div className="flex gap-4">
                    <ShowUnpublishedCaselet />
                </div>
            </div> */}
        </div>
    );
};

export default HomePage;
